import { Button } from '@eventbrite/eds-button';
import { gettext } from '@eventbrite/i18n';
import { logEvent } from '@eventbrite/statsig';
import React from 'react';
import { STATSIG_EVENT_NAMES } from '../../../experimentation';
import { EventDetailsMainInner } from '../EventDetails';

interface ViewMoreDetailsProps {
    onViewAllDetailsClick: Function;
}

export const ViewMoreDetails = ({
    onViewAllDetailsClick,
}: ViewMoreDetailsProps) => {
    const handleClick = () => {
        onViewAllDetailsClick();
        logEvent(STATSIG_EVENT_NAMES.LISTING_ALL_EVENT_DETAILS_VIEW);
    };

    return (
        <EventDetailsMainInner>
            <div className="event-listing__view-more-details-btn-container">
                <Button
                    data-testid="view-event-details-button"
                    style="neutral"
                    type="button"
                    onClick={handleClick}
                >
                    {gettext('View all event details')}
                </Button>
            </div>
        </EventDetailsMainInner>
    );
};
